<template>
  <div>
    <div class="ps-4">
      <section-header v-if="!hideTitle"
                      :ressource="ressource"
                      :isExtended="extended"
                      :dialog="dialog"
                      @extended=setExtended
                      @closeDialog=closeDialog
                      ref="CART">
      </section-header>
    </div>

    <v-data-table :calculate-widths="true"
                  no-data-text="Aucune donnée"
                  :headers="headers"
                  :items="bankDays"
                  :height="300"
                  :items-per-page="-1"
                  class="white"
                  disable-pagination
                  fixed-header
                  hide-default-footer
                  @click:row="selectBankDay">
      <template v-slot:[`item.dateReleve`]="{ item }">
        {{ formatDate(item.dateReleve) }}
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-row class="m-0">
          <div class="col-2">
            <v-icon @click.stop="reloadBankDay(item)" size="25" color="green">fas fa-landmark</v-icon>
          </div>
        </v-row>
      </template>
    </v-data-table>
  </div>
</template>

<script lang="ts">
  import { GenControl, GenSection, RessourceGenControl, RessourceGenSection } from '@/generated/ressources/generatedRessources';
  import { FwkButtons, RessourceFwkButton, RessourceFwkSection, FwkSections } from '@/ressources/globalRessources';
  import { Sections } from '@/generated/classes/AppSchema';
  import BankLog, { BankDay } from '@/generated/classes/BankLog';
  import SectionHeader from '@/framework/base/components/SectionHeader.vue';
  import { Extended } from '@/framework/base/classes/Schema';
  import { DateFormat } from "@/framework/base/helpers/DateFormat";
  import { defineComponent } from "vue";

  export default defineComponent({
    components: {
      SectionHeader
    },
    props: {
      hideTitle: {
        type: Boolean
      },
      extended: {
        type: Boolean
      },
      dialog: {
        type: Boolean
      }
    },
    created() {
      BankLog.ListByDay().then((list: BankDay[]) => {
        this.bankDays = list;
      })
    },
    data() {
      const bankDays: BankDay[] = [];

      return {
        dialogOpen: false,
        bankDays,
        loading: false,
        headers: [
          { title: 'Date relevé', key: 'dateReleve', sortable: true },
          { title: 'Nombre d\'écritures', key: 'nbEcritures', sortable: true },
          { title: 'Crédit', key: 'credit', sortable: true },
          { title: 'Débit', key: 'debit', sortable: true },
          { title: 'Nb rapprochements', key: 'nbRapprochements', sortable: true },
          { title: 'N forçages', key: 'nbForcages', sortable: true },
          { text: '', width: '5%', value: 'action', cellClass: 'iterate-cell-class iterate-cell-action', sortable: false },
        ],
        sectionName: Sections.BANK_LIST
      };
    },
    computed: {
      saveLabel() {
        return RessourceFwkButton(FwkButtons.ENREGISTRER).label;
      },
      errorTxt() {
        return RessourceFwkSection(FwkSections.ERROR_TEXT).label;
      },
      ressource() {
        return RessourceGenSection(GenSection.BANK_LIST);
      }
    },

    methods: {
      formatDate(value: string): string {
        return DateFormat.toEdit(value);
      },
      setExtended(extended: Extended): void {
        this.$emit('extended', extended);
      },
      closeDialog() {
        this.$emit('closeDialog');
      },
      openDialog() {
        this.dialogOpen = true;
      },
      selectBankDay(e: Event, value: any) {
        const bankDay = value.item as BankDay
        this.$emit('updated', bankDay);
      },
      reloadBankDay(value: BankDay) {
        if (!this.loading) {
          this.loading = true;
          BankLog.LoadDay(value).then((res) => {
            if (res) {
              BankLog.ListByDay().then((list: BankDay[]) => {
                this.bankDays = list;
                this.$emit('updated', value);
              })
            }
            this.loading = false;
          }).catch((err) => {
            BankLog.ListByDay().then((list: BankDay[]) => {
              this.bankDays = list;
              this.$emit('updated', value);
              this.loading = false;
            })
          });
        }
      }
    }
  })

</script>
